module.exports = __webpack_public_path__ + "static/media/add.e529cf1e.svg";